/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <billing-address-form
  :billingAddressFields="billingAddressFields"
  :busListener="busListener"
  :isPickupSelected="isPickupSelected"
  name="billing-address-form"
  ref="billing-address-form"
  v-model="billingFormValue"
  v-validate="'required:true'"
  @updateAddress="updateAddress"
  @next-step="$emit('next-step')"
  />
</template>

<script>
// import BillingAddressForm from './BillingAddressForm'
import some from 'lodash/some'

export default {
  name: 'Addresses',
  props: {
    name: {
      type: String,
      default: () => 'shipping-section'
    },
    busListener: {
      type: String,
      required: false
    },
    isPickupSelected: {
      type: Boolean,
      default: false
    }
  },
  $_veeValidate: {
    validator: 'new',
    value () {
      return this.isValidForm
    },
    name () {
      return this.name
    }
  },
  data () {
    return {
      billingAddressFields: { ...this.$store.state.checkout.billingAddress },
      billingFormValue: false
    }
  },
  watch: {
    isValidForm (val) {
      // used for validation parents
      this.$emit('input', val)
    }
  },
  computed: {
    isValidForm () {
      return !some(this.veeFields, { invalid: true })
    }
  },
  methods: {
    changeCountry (newCountry) {
      console.log('change country', newCountry)
    },
    init () {
      // called from parent
      this.billingAddressFields = { ...this.$store.state.checkout.billingAddress }
      this.$refs['billing-address-form'] && this.$refs['billing-address-form'].init()
    },
    updateAddress (address) {
      this.$store.commit('checkout/setBillingAddress', address)
      this.billingAddressFields = { ...this.billingAddressFields, ...address }
    }
  },
  components: {
    BillingAddressForm: () => import('theme/components/Checkout/OnePage/BillingAddressForm')
  }
}
</script>
